"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function comp(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.615 16.1901C6.42858 16.0799 6.27392 15.9232 6.16613 15.7353C6.05834 15.5475 6.0011 15.3349 6 15.1183V12.6786C6 12.3884 6.2415 12.1536 6.537 12.1551C6.6315 12.1551 6.7245 12.1798 6.807 12.2263L12.4343 15.4371C12.7635 15.6246 12.9667 15.9696 12.9667 16.3423V18.8698C12.9663 18.9534 12.9493 19.036 12.9167 19.113C12.8842 19.1899 12.8368 19.2597 12.7772 19.3182C12.7176 19.3768 12.647 19.423 12.5695 19.4541C12.492 19.4853 12.409 19.5008 12.3255 19.4998C12.2068 19.4999 12.0902 19.468 11.988 19.4076L6.615 16.1901ZM15.003 11.5581C15.333 11.7456 15.534 12.0913 15.5355 12.4633V17.5933C15.5355 17.7448 15.453 17.8851 15.3173 17.9586L14.0858 18.6366C14.0699 18.6454 14.053 18.6522 14.0355 18.6568V15.8083C14.0355 15.4393 13.8382 15.0973 13.5135 14.9083L8.5725 12.0148V8.7996C8.5725 8.50935 8.814 8.2746 9.11025 8.2761C9.20464 8.27624 9.29739 8.30079 9.3795 8.34735L15.0045 11.5581H15.003ZM17.4667 7.7691C17.7968 7.9566 18 8.3016 18 8.67585V16.1683C17.9991 16.2445 17.9776 16.3189 17.9379 16.3839C17.8981 16.4488 17.8416 16.5019 17.7743 16.5373L16.6065 17.1546V11.9376C16.6065 11.5693 16.4085 11.2281 16.0868 11.0383L11.0347 8.0736V5.02485C11.0347 4.93185 11.061 4.8411 11.1068 4.76085C11.1803 4.64023 11.2979 4.55296 11.4347 4.51755C11.5715 4.48213 11.7166 4.50134 11.8395 4.5711L17.4667 7.76985V7.7691Z", fill: color }));
}
exports["default"] = comp;
//# sourceMappingURL=comp.js.map